import { getUserCouponsReqObj as t } from "../config/couponSearchApiEndPoints.js";
import { handleRequest as s } from "../../utils/commonHelper.js";
const a = {
  getUserCoupons(o, r) {
    const e = t();
    return e.params = o, s(e, r);
  }
};
export {
  a as couponSearchApi,
  a as default
};
//# sourceMappingURL=couponSearchApi.js.map
